module.exports = __webpack_public_path__ + "img/backgroundStarWhiteBig.5ed3b10e.svg";